import Axios, { AxiosAdapter, InternalAxiosRequestConfig } from 'axios';
import { sha256Hex } from './sha256';

export const adapter: AxiosAdapter = async (
    request: InternalAxiosRequestConfig
) => {
    const headers = request.headers;
    let data = request.data;
    if (
        (headers['Content-Type'] ?? headers['content-type']) ===
            'application/json' &&
        data !== undefined
    ) {
        if (typeof data !== 'string') {
            data = JSON.stringify(data);
            request.data = data;
        }
    }
    if (/post|put/i.test(request.method ?? '') && !(data instanceof Blob)) {
        headers['x-amz-content-sha256'] = await sha256Hex(data);
    }
    return await Axios.getAdapter(Axios.defaults.adapter)(request);
};
